export const MACHINE_STATUSES = ['running', 'idle', 'alarm', 'offline'] as const;
export type MachineStatus = (typeof MACHINE_STATUSES)[number];

export const CONTROLLER_TYPES = [
  'fanuc_0i_md',
  'fanuc_30i',
  'mazak_matrix',
  'mazak_smoothx',
  'haas_nextgen',
  'mori_mapps',
  'okuma_osp',
  'siemens_840d',
  'heidenhain_tnc',
  'unknown',
] as const;
export type ControllerType = (typeof CONTROLLER_TYPES)[number];
